import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { LazyLoaderContainer } from "./src/lazy-loader.container";

@NgModule({
	imports: [CommonModule],
	declarations: [LazyLoaderContainer],
	exports: [LazyLoaderContainer],
})
export class LazyLoaderModule {}
